// NPM Imports
import React from 'react'
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'

export default function PrepaymentDifferenceRow({
   order = 1,
}: {
   order?: number
}) {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state

   const permissionChoosePrepaymentType =
      state.featurePermissions['ChoosePrepaymentType']
   // const permissionDiffQuote = state.featurePermissions["DifferenceQuote"];
   // const diffQuotePermission = permissionDiffQuote?.includes(state.user_role) ?? false;
   const ChoosePrepaymentTypePermission =
      permissionChoosePrepaymentType?.includes(state.user_role) ?? false

   // Show when prepayLength > 1 AND a Prepayment Discount is selected
   if (
      state.user_view != 'External' &&
      ChoosePrepaymentTypePermission &&
      state.prepayLength > 1 &&
      state.differenceQuote
   )
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1 hoverable'>
               <DiscountDescriptionBox
                  discountDescription={getString(
                     'product.PrepaymentDifferenceRow.DiscountDescriptionBox.Description',
                  )}
                  discountName={getString(
                     'product.PrepaymentDifferenceRow.DiscountDescriptionBox.DiscountName',
                  )}
                  hoverTitle={getString(
                     'product.PrepaymentDifferenceRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.prepaymentActivationUseDifference}
                  onChange={() =>
                     state.setPrepaymentActivationUseDifference(
                        (prev: boolean) => !prev,
                     )
                  }
                  aria-label='Use Difference Amount for Full Prepayment Term'
               ></input>
            </div>
         </div>
      )
}
